import { c as r } from "./index.mjs";
const s = () => r.useAirport();
export {
  s as u
};
